module.exports = __webpack_public_path__ + "img/serova_logo_blue.39cf3650.png";